"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./InputErrorMessage.scss");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * 
 */
var InputErrorMessage = function InputErrorMessage(props) {
  var className = 'c-InputErrorMessage';
  var _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      errorMessage = props.errorMessage,
      id = props.id;
  if (!error) return null;
  return _react2.default.createElement("div", {
    id: id ? id : null,
    className: className,
    role: "alert",
    "aria-live": "assertive",
    name: id
  }, errorMessage);
};

exports.default = InputErrorMessage;